import moment from 'moment';

export const getNowMs = () => {
    return moment(new Date()).utc().valueOf();
};
